export default {
  email: window.localStorage.getItem('email') || '',
  password: window.localStorage.getItem('password') || '',
  saveEmailPass: window.localStorage.getItem('saveEmailPass')
}
